import type { PropertyFilterQuery } from '@cloudscape-design/collection-hooks';
import type { FilterGroup } from '@risksmart-app/shared/reporting/api/schema';

import type { TypedCustomDatasource } from '../types';
import type { Filters } from '../update/customDatasourceSchema';
import { mapQueryToFilterGroup } from '../update/formDataMapping';

export const combinedFilters = (
  customDatasource: Pick<TypedCustomDatasource, 'Filters'>,
  propertyFilter: PropertyFilterQuery | undefined,
  dashboardFilters?: FilterGroup
) => {
  // Only whole filter groups are pushed, so type this as FilterGroup[] rather
  // than the looser (Filter | FilterGroup)[] — that lets the single-element
  // return narrow to FilterGroup, matching the shared ReportingDataInput.filters
  // contract the tRPC reporting read requires.
  const filters: FilterGroup[] = [];
  if (customDatasource.Filters && customDatasource.Filters.filters.length > 0) {
    filters.push(customDatasource.Filters);
  }
  if (
    propertyFilter &&
    propertyFilter.tokenGroups &&
    propertyFilter.tokenGroups.length > 0
  ) {
    filters.push(mapQueryToFilterGroup(propertyFilter as Filters));
  }
  if (dashboardFilters && dashboardFilters.filters.length > 0) {
    filters.push(dashboardFilters);
  }

  if (filters.length === 1) {
    return filters[0];
  }
  const combinedFilters: FilterGroup = {
    operation: 'and',
    filters,
  };

  return combinedFilters;
};
